window.addEventListener("scroll", function() {
    if (window.scrollY >= 50) document.querySelector("body").classList.add("scrolled");
    else document.querySelector("body").classList.remove("scrolled");
});
window.addEventListener("load", function() {
    if (window.scrollY >= 50) document.querySelector("body").classList.add("scrolled");
    else document.querySelector("body").classList.remove("scrolled");
});

//# sourceMappingURL=landing-page.55d882f6.js.map
